import Navbar from "../layout/Navbar";
import React from "react";
import Footer from "../layout/Footer";
import revolution2 from "../assests/Images/RevolutionizingSales_Project2.jpg";
import { LuNewspaper } from "react-icons/lu";
import orsac from "../assests/Images/ORSAC_Project.jpg";
import redefining_project2 from "../assests/Images/Redefining_Project2.jpg";
import CoverPhoto from "../assests/Images/about-us-cover-photo.jpg";
import { Link } from "react-router-dom";
import WaveEffect from "../Components/WaveEffect";

const ORSACProject = () => {
  return (
    <div>
      <Navbar />
      <div
        className="bg-cover bg-center h-[50vh] lg:h-[75vh] md:h-[500px] sm:h-[400px] sm:rounded-tl-[390px] xl:rounded-tl-[400px]"
        style={{ backgroundImage: `url(${CoverPhoto})` }}
      >
        <div className="h-full bg-black bg-opacity-80 w-full flex flex-col justify-center items-center sm:rounded-tl-[390px] xl:rounded-tl-[400px] ">
          <WaveEffect
            text="GIS & Remote Sensing Applications"
            textClassName="text-white text-xl lg:text-5xl xl:text-5xl 2xl:text-3xl sm:text-3xl 2xl:text-8xl font-bold"
          />
          <div className="h-1 lg:h-2 xl:h-2 2xl:h-2 mt-4 w-24 bg-white" />
        </div>
      </div>

      <div className="m-10 xl:m-28 lg:m-20 md:m-16 sm:m-10 flex flex-col xl:flex-row lg:flex-row md:flex-col sm:flex-col gap-20 h-full sm:mt-10 ">
        <div className="w-full  ">
          <img
            src={orsac}
            alt=""
            className="lg:h-[35rem] lg:w-full h-full w-full rounded-xl object-cover"
          />
        </div>

        <div className="flex justify-center">
          <div className="w-[35rem] h-fit shadow-lg p-10 md:w-[25rem]  sm:w-[20rem]  place-items-center ">
            <div className="flex flex-row gap-2 justify-start items-center border-b-2 border-gray-300">
              <LuNewspaper className="text-2xl text-primary" />
              <h1 className="text-2xl font-bold pb-4 text-center">
                Recent Case Studies
              </h1>
            </div>

            <div className="flex flex-row gap-3 border-b-2 border-gray-300 py-5">
              <img
                src={orsac}
                alt=""
                className=" h-14 w-full object-contain rounded-2xl"
              />
              <div className="w-full ">
                <h1 className="text-gray-500">April 3, 2025</h1>
                <Link to="/orsac-project" className="hover:text-primary">
                  <p className="font-semibold text-lg">GIS & Remote Sensing Applications</p>
                </Link>
              </div>
            </div>

            <div className="flex flex-row gap-3 border-b-2 border-gray-300 py-5">
              <img
                src={revolution2}
                alt=""
                className=" h-16 w-full object-contain rounded-2xl"
              />
              <div className="w-full ">
                <h1 className="text-gray-500">September 9, 2020</h1>
                <Link
                  to="/redefining-productivity-incentives"
                  className="hover:text-primary"
                >
                  <p className="font-semibold text-lg">
                    Redefining Productivity Incentives
                  </p>
                </Link>
              </div>
            </div>

            <div className="flex flex-row gap-3 py-5">
              <img
                src={redefining_project2}
                alt=""
                className="h-14 w-full object-contain rounded-2xl"
              />
              <div className="w-full ">
                <h1 className="text-gray-500">September 9, 2020</h1>
                <Link
                  to="/revolutionizing-sales-operations"
                  className="hover:text-primary"
                >
                  <p className="font-semibold text-lg">
                    Revolutionizing Sales Operations
                  </p>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-col justify-center items-center text-start gap-10 lg:px-28 px-10 text-lg mb-20">
        <p>
          At People Process Teck, we specialize in GIS and Remote Sensing
          technologies to develop advanced applications for industries like
          renewable energy, logistics, infrastructure, and environmental
          management. Our skilled manpower, deployed at Odisha Satellite
          Applications Center (ORSAC), is actively engaged in building
          cutting-edge geospatial solutions to support data-driven
          decision-making.
        </p>
        <p>
          <span className="font-semibold text-primary">
            Land Use & Site Selection:
          </span>{" "}
          Using satellite imagery and GIS analytics, we help identify optimal
          locations for infrastructure projects, solar farms, and industrial
          zones. Disaster Management & Risk Assessment: Our GIS applications
          assist in flood prediction, cyclone tracking, and environmental impact
          analysis for proactive disaster response.
        </p>
        <p>
          <span className="font-semibold text-primary">
            Renewable Energy Mapping:
          </span>{" "}
          We leverage remote sensing data to analyze solar radiation, wind
          patterns, and terrain suitability for green energy projects. Urban &
          Infrastructure Planning: ORSAC-based solutions support smart city
          development, road network planning, and resource allocation.
        </p>
      </div>

      <Footer />
    </div>
  );
};

export default ORSACProject;
